<app-header></app-header>
<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance" *ngIf="showMessage">
                                     {{slide.type}}
                                </span>
                                <span class="assurance" *ngIf="!showMessage">
                                   Votre compte n'a pas été activé. Veuillez contacter l'administrateur
                               </span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" *ngIf="showMessage" [src]="slide.imgIcon" alt="">
                                <img class="assu-img" *ngIf="!showMessage" [src]="slide.imgIconError" alt="">
                            </div>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" routerLink="/">Continuer</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>